<template>
  <div>
    <a-modal
      width="40%"
      title="工作室基本信息"
      destroy-on-close
      :visible.sync="visible"
      append-to-body
      ok-text="提交"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div class="card-item">
        <div>
          <div class="mt30">
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f">*</span> 工作室名称
              </div>
              <div class="pl16">
                <a-input
                  class="input-style-2"
                  type="text"
                  placeholder="请输入工作室名称"
                  :maxLength="100"
                  v-model="info.name"
                  :disabled="isEdit || !isbj"
                />
              </div>
            </div>
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f">*</span> 申报年份
              </div>
              <!-- :disabled="isEdit || !isbj" -->
              <div class="pl16">
                <a-date-picker
                  placeholder="请选择申报年份"
                  v-model="info.applyYear"
                  :disabled="isEdit"
                  :open="yearShowOne"
                  :locale="locale"
                  :format="'YYYY'"
                  mode="year"
                  @openChange="openChangeOne"
                  @panelChange="panelChangeOne"
                  class="form-item-right"
                />
              </div>
            </div>
          </div>
          <div class="mt30">
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f">*</span> 工作室地点
              </div>
              <div class="pl16">
                <a-input
                  class="input-style-2"
                  type="text"
                  :maxLength="50"
                  placeholder="请输入工作室地点"
                  v-model="info.address"
                  :disabled="isEdit"
                />
                <!--  -->
              </div>
            </div>
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f">*</span> 场所面积
              </div>
              <div class="pl16 plflex">
                <a-input
                  class="input-style-2"
                  type="text"
                  pattern="[1-9]\d*"
                  placeholder="请输入场所面积"
                  v-model="info.acreage"
                  style="width: 86%"
                  :disabled="isEdit"
                />
                <span class="text2">平米</span>
              </div>
              <!-- -->
            </div>
          </div>
          <div class="mt30">
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f">*</span> 所属部门
              </div>
              <div class="pl16">
                <a-input
                  class="input-style-2"
                  type="text"
                  placeholder="请输入所属部门"
                  :maxLength="100"
                  v-model="info.belongDepartment"
                  :disabled="isEdit"
                />
              </div>
            </div>
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f">*</span> 建设日期
              </div>
              <div class="pl16">
                <a-date-picker
                  placeholder="请选择建设日期"
                  v-model="info.foundTime"
                  :disabled="isEdit"
                  :format="'YYYY-MM-DD'"
                  :locale="locale"
                  class="form-item-right"
                />
              </div>
            </div>
          </div>
          <div class="mt30">
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f"></span>全校师生对工作室知晓度
              </div>
              <div class="pl16 flex align-items-center">
                <a-input-number
                  v-model="info.tsSzgzsKnow"
                  precision="0"
                  :disabled="isEdit"
                  class="percentage-text"
                />
                <span class="text2">%</span>
              </div>
            </div>

            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f"></span>全校师生对工作室服务满意度
              </div>
              <div class="pl16 flex align-items-center">
                <a-input-number
                  v-model="info.tsSzgzsSatisfied"
                  precision="0"
                  :disabled="isEdit"
                  class="percentage-text"
                />
                <span class="text2">%</span>
              </div>
            </div>
          </div>
          <div class="mt30">
            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f"></span
                >项目被省级或国家级媒体报道次数
              </div>
              <div class="pl16 flex align-items-center">
                <a-input-number
                  v-model="info.reportNum"
                  precision="0"
                  :disabled="isEdit"
                  class="percentage-text"
                />
                <span
                  class="percentage-sign"
                  v-if="info.id"
                  @click="showevidence(0)"
                  >佐证</span
                >
              </div>
            </div>

            <div class="form-item">
              <div class="main-text-style">
                <span style="color: #f6350f"></span
                >省内外同类院校前来交流学习次数
              </div>
              <div class="pl16 flex align-items-center">
                <a-input-number
                  v-model="info.conmunicateNum"
                  precision="0"
                  :disabled="isEdit"
                  class="percentage-text"
                />
                <span
                  class="percentage-sign"
                  v-if="info.id"
                  @click="showevidence(1)"
                  >佐证</span
                >
              </div>
            </div>
          </div>
          <!--<div class="mt30">
        <div>
          <div class="main-text-style">
            <span style="color: #f6350f">*</span> 联系电话
          </div>
          <div class="pl16">
            <a-input
              class="input-style-2"
              type="text"
              :maxLength="11"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              placeholder="请输入联系电话"
              v-model="info.phone"
              :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'"
            />
          </div>
        </div>
      </div>-->
          <!-- <div class="text1">申报书模板下载</div>
        <div class="flex align-items-center">
          <img class="img-box-4" src="../../assets/images/img39.png" alt="" />
          <div class="text2" style="color: #2155B5; cursor: pointer">
            <a
              href="/思政教育工作室项目申报书.docx"
              download="思政微课项目申报书.docx"
              style="color: #2155B5"
            >
              思政教育工作室申报书.docx</a
            >
            <span class="text2">(32.2KB)</span>
          </div>
        </div>
      </div>-->
          <div class="mt30">
            <div class="form-item-upload">
              <div class="main-text-style">
                <span style="color: #f6350f">*</span>
                工作室运行状态
              </div>
              <div class="pl16">
                <a-switch
                  checked-children="开"
                  un-checked-children="关"
                  :disabled="isEdit"
                  style="margin-bottom: 5px"
                  v-model="info.studioStatus"
                />
              </div>
            </div>
          </div>
          <div class="mt30">
            <div class="form-item-upload">
              <div class="main-text-style">
                <span style="color: #f6350f">*</span>
                申报书上传
              </div>
              <div class="pl16">
                <a-upload
                  :file-list="fileList"
                  :disabled="isEdit"
                  :remove="(file, fileList) => handleRemove(file, fileList)"
                  :before-upload="
                    (file, fileList) => beforeUpload(file, fileList)
                  "
                  accept=".pdf"
                  :style="{ cursor: isEdit ? 'pointer' : '' }"
                  @preview="handlePreview"
                >
                  <a-button :disabled="isEdit || loading" :loading="loading">
                    <a-icon type="upload" />上传附件
                  </a-button>
                  <span class="text2">注：请上传pdf格式的文件</span>
                </a-upload>
              </div>
            </div>
          </div>
          <div class="mt30">
            <div class="form-item-upload">
              <div class="main-text-style">
                <span style="color: #f6350f"></span>
                建设方案上传
              </div>
              <div class="pl16">
                <a-upload
                  :file-list="fileList1"
                  :disabled="isEdit"
                  :remove="(file, fileList) => handleRemove1(file, fileList)"
                  :before-upload="
                    (file, fileList) => beforeUpload1(file, fileList)
                  "
                  accept=".pdf"
                  :style="{ cursor: isEdit ? 'pointer' : '' }"
                  @preview="handlePreview"
                >
                  <a-button :disabled="isEdit || loadings" :loading="loadings">
                    <a-icon type="upload" />上传附件
                  </a-button>
                  <span class="text2">注：请上传pdf格式的文件</span>
                </a-upload>
              </div>
            </div>
          </div>
          <div class="mt30">
            <div class="form-item-upload">
              <div class="main-text-style">
                <span style="color: #f6350f; opacity: 0"></span>
                校方承诺书上传
              </div>
              <div class="pl16">
                <a-upload
                  :file-list="letterList"
                  :disabled="isEdit"
                  :remove="
                    (file, fileList) => handleRemoveLetter(file, fileList)
                  "
                  :before-upload="
                    (file, fileList) => beforeUploadLetter(file, fileList)
                  "
                  accept=".pdf"
                  :style="{ cursor: isEdit ? 'pointer' : '' }"
                  @preview="handlePreview"
                >
                  <a-button
                    :disabled="isEdit || letterLoading"
                    :loading="letterLoading"
                  >
                    <a-icon type="upload" />上传附件
                  </a-button>
                  <span class="text2">注：请上传pdf格式的文件</span>
                </a-upload>
              </div>
            </div>
          </div>
        </div>
        <div class="preview-pop-box" v-if="showtable">
          <div class="preview-boxs">
            <evidencelist
              :title="title"
              :dataid="dataid"
              :code="code"
              :isEdit="isEdit"
              :id="id"
              @closePreview="showtable = false"
            >
            </evidencelist>
          </div>
        </div>
        <div class="preview-pop-box" v-if="showiframe">
          <div class="preview-boxs" style="height: 90%">
            <newpreview
              :previewUrl="previewUrl"
              @closePreview="showiframe = false"
              :dialogTitle="titlename"
            ></newpreview>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
import { baseURL } from "@/utils/request.js";
import { postAction } from "@/api";
import evidencelist from "@/components/common/evidencelist";
import newpreview from "@/components/common/newpreviews";
export default {
  name: "",
  components: {
    evidencelist,
    newpreview,
  },
  data() {
    return {
      visible: false,
      isEdit: false,
      info: {
        applyType: "1",
        name: "",
        address: "",
        foundTime: "",
        applyYear: "",
        id: "",
        declarationName: "",
        declarationPath: "",
        acreage: "",
        belongDepartment: "",
        tsSzgzsKnow: "",
        tsSzgzsSatisfied: "",
        reportNum: "",
        conmunicateNum: "",
        letterOfCommitmentName: "",
        letterOfCommitmentPath: "",
        studioStatus: true, // true=开(0) false=关(1)，与保存逻辑一致
      },
      dataid: "",
      showtable: false,
      zh_CN,
      locale,
      yearShowOne: false,
      path: baseURL,
      fileList: [],
      fileList1: [],
      letterList: [],
      loading: false,
      loadings: false,
      letterLoading: false,

      title: "",
      id: "",
      code: "",
      showiframe: false,
      previewUrl: "",
      titlename: "",
      // isbj:true,
      isxg: false,
      sj: {},
      taskId: null,
      detailId: null,
    };
  },
  methods: {
    init(type, data, taskId, detailId) {
      console.log("🚀 ~ init ~ data:", data);
      this.visible = true;
      this.taskId = taskId;
      this.detailId = detailId;
      if (data != null) {
        this.info = { ...data };
        if (
          data &&
          data.declarationName != "" &&
          data.declarationName != null &&
          data.declarationPath != "" &&
          data.declarationPath != null
        ) {
          this.fileList = [];
          let fileItem = {};
          fileItem.path = data.declarationPath;
          fileItem.name = data.declarationName;
          fileItem.uid = 1;
          this.fileList.push(fileItem);
        }
        if (
          data &&
          data.activityPlanName != "" &&
          data.activityPlanName != null &&
          data.activityPlanPath != "" &&
          data.activityPlanPath != null
        ) {
          this.fileList1 = [];
          let fileItem = {};
          fileItem.path = data.activityPlanPath;
          fileItem.name = data.activityPlanName;
          fileItem.uid = 2;
          this.fileList1.push(fileItem);
        }
        if (
          data &&
          data.letterOfCommitmentName != "" &&
          data.letterOfCommitmentName != null &&
          data.letterOfCommitmentPath != "" &&
          data.letterOfCommitmentPath != null
        ) {
          this.letterList = [];
          let fileItem = {};
          fileItem.path = data.letterOfCommitmentPath;
          fileItem.name = data.letterOfCommitmentName;
          fileItem.uid = 2;
          this.letterList.push(fileItem);
        }
        if (
          data &&
          (data.studioStatus === 0 ||
            data.studioStatus === 1 ||
            data.studioStatus === "0" ||
            data.studioStatus === "1")
        ) {
          // 仅在接口原始值 0/1 时转换；切换后为 boolean，勿再覆盖
          this.info.studioStatus = String(data.studioStatus) === "0";
        }
        if (this.$parent.editInfo && this.$parent.editInfo?.type == "preview") {
          this.isEdit = true;
        }
      }
      console.log("🚀 ~ init ~ this.info:", this.info);
    },
    handleRemove(file, fileList) {
      this.fileList = this.fileList.filter((item) => {
        if (item.path.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    handleRemove1(file, fileList) {
      this.fileLis1t = this.fileList1.filter((item) => {
        if (item.path.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.fileList1.indexOf(file);
      const newFileList = this.fileList1.slice();
      newFileList.splice(index, 1);
      this.fileList1 = newFileList;
    },
    beforeUpload1(file, fileList) {
      this.handleUpload1(file);
      return false;
    },
    handleUpload1(file) {
      if (this.fileList1.length >= 1) {
        this.$message.error("建设方案只能上传一个文件,请移除后再上传");
        return;
      }
      this.loadings = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.path = res.message;
          fileItem.name = file.name;
          fileItem.uid = file.uid;
          this.fileList1.push(fileItem);
          this.loadings = false;
        } else {
          this.$message.error("上传失败");
          this.loadings = false;
        }
      });
    },
    beforeUpload(file, fileList) {
      this.handleUpload(file);
      return false;
    },
    handleUpload(file) {
      if (file.type != "application/pdf") {
        this.$message.error("请上传规定格式的文件");
        return false;
      }
      if (this.fileList.length >= 1) {
        this.$message.error("申报书只能上传一个文件,请移除后再上传");
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.path = res.message;
          fileItem.name = file.name;
          fileItem.uid = file.uid;
          this.fileList.push(fileItem);
          this.loading = false;
        } else {
          this.$message.error("上传失败");
          this.loadings = false;
        }
      });
    },
    handleOk() {
      if ((this.info && this.info.name == "") || this.info.name == undefined) {
        this.$message.info("请填写工作室名称");
        return false;
      } else if (
        (this.info && this.info.applyYear === "") ||
        this.info.applyYear == undefined
      ) {
        this.$message.info("请选择申报年份");
        return false;
      } else if (
        (this.info && this.info.address === "") ||
        this.info.address == undefined
      ) {
        this.$message.info("请填写工作室地点");
        return false;
      }
      if (
        (this.info && this.info.acreage === "") ||
        this.info.acreage == undefined
      ) {
        this.$message.info("请填写思政教育工作室面积");
        return false;
      } else {
        let telStr = /^(0*[1-9]\d*\.?\d+|[1-9]\d*)$/;
        if (!telStr.test(this.info.acreage)) {
          this.$message.info("输入的思政教育工作室面积格式不正确");
          return false;
        }
      }
      if (
        (this.info && this.info.belongDepartment === "") ||
        this.info.belongDepartment == undefined
      ) {
        this.$message.info("请填写思政教育工作室所属部门");
        return false;
      }
      if (
        (this.info && this.info.foundTime === "") ||
        this.info.foundTime == undefined
      ) {
        this.$message.info("请选择工作室建设日期");
        return false;
      }
      //    else {
      //      var telStr = /^[1]([3-9])[0-9]{9}$/;
      //      if (!telStr.test(this.info.phone)) {
      //        this.$message.info("请输入正确格式手机号");
      //        return false;
      //      }
      //    }

      if (this.fileList.length == 0) {
        this.$message.info("请上传申报书");
        return false;
      }
      this.isEdit = false;
      const dateObj = new Date(this.info.foundTime);
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth() + 1; // 月份是从 0 开始的，所以要加 1
      const date = dateObj.getDate();
      const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${date
        .toString()
        .padStart(2, "0")}`;

      let params = {
        applyType: this.info.applyType,
        name: this.info.name,
        address: this.info.address,
        foundTime: formattedDate,
        applyYear: new Date(this.info.applyYear).getFullYear() + "",
        id: this.info.id,
        declarationName: this.fileList[0].name,
        declarationPath: this.fileList[0].path,
        acreage: this.info.acreage,
        belongDepartment: this.info.belongDepartment,
        tsSzgzsKnow: this.info.tsSzgzsKnow,
        tsSzgzsSatisfied: this.info.tsSzgzsSatisfied,
        reportNum: this.info.reportNum,
        conmunicateNum: this.info.conmunicateNum,
        activityPlanName: "",
        activityPlanPath: "",
        letterOfCommitmentName: "", //  承诺书名称
        letterOfCommitmentPath: "", //承诺书路径
      };
      this.info.declarationName = this.fileList[0].name;
      this.info.declarationPath = this.fileList[0].path;
      if (this.fileList1.length > 0) {
        params.activityPlanName = this.fileList1[0].name;
        params.activityPlanPath = this.fileList1[0].path;
        this.info.activityPlanName = this.fileList1[0].name;
        this.info.activityPlanPath = this.fileList1[0].path;
      }
      if (this.letterList.length > 0) {
        params.letterOfCommitmentName = this.letterList[0].name;
        params.letterOfCommitmentPath = this.letterList[0].path;
        this.info.letterOfCommitmentName = this.letterList[0].name;
        this.info.letterOfCommitmentPath = this.letterList[0].path;
      }
      params.studioStatus = this.info.studioStatus ? "0" : "1";

      this.sj = params;
      this.gosave();
    },
    gosave() {
      let params = {
        taskId: this.taskId,
        afterJson: JSON.stringify({ ...this.sj }),
        detailId: this.detailId,
      };
      postAction("/audit/lxAuditTask/reSubmitTask", params).then((res) => {
        if (res.code == 200) {
          //              this.visible = false;
          this.$message.success(res.message || "保存成功");
          this.info.id = res.result.id;
          this.visible = false;
          this.$emit("init", this.info);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleCancel() {
      this.visible = false;
    },
  },
  mounted() {},
};
</script>
<style scoped lang="scss">
.card-item {
  //   background: #ffffff;
  //   box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.11);
  //   padding: 37px 20px;
  //   box-sizing: border-box;
  //   margin-bottom: 24px;
  .title-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 700;
    border-bottom: 1px solid #d9d9d9;
    .title-text {
      color: #2155b5;
      font-size: 20px;
      font-weight: bold;
      height: 40px;
      line-height: 40px;
      border-bottom: 3px solid #2155b5;
      padding: 0px 4px;
    }
    .btn-action {
      width: 100px;
      height: 30px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
}
.mt30 {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .form-item {
    display: flex;
    align-items: center;
    width: 50%;
    margin-bottom: 10px;
    .main-text-style {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #121212;
      margin-bottom: 15px;
      width: 165px;
    }
    .pl16 {
      width: calc(100%- 235px);
    }
    .form-item-right {
      width: 100%;
    }
    // .form-item-right {
    //   width: 240px;
    // }
  }
  .form-item-upload {
    display: flex;
    align-items: center;
    .main-text-style {
      font-size: 19px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-bottom: 15px;
      width: 165px;
    }
    .form-item-right {
      width: 240px;
    }
  }
}
.submit-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  .btn-group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 240px;
    margin-top: 50px;
    .btn-action {
      width: 116px;
      height: 40px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      line-height: 38px;
      text-align: center;
    }
  }
}

.input-style-2 {
  width: 100%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
// /deep/ .ant-calendar-picker {
//   width: 50%;
// }
/deep/ .ant-input {
  width: 100%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
.plflex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.mb15 {
  margin: 20px;
  width: 165px;
}
.mb15-item {
  border-bottom: 1px solid #e4e0e0;
  padding-bottom: 30px;
  margin-bottom: 30px;
}

.img-box {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
.img-box-2 {
  width: 19px;
  height: 19px;
  margin-right: 10px;
}
.text2 {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin: 14px 0 15px 10px;
}
.img-box-4 {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.file-input-box {
  color: #2155b5;
}
.file {
  position: relative;
  width: 156px;
  height: 40px;
  background: #fff;
  border: 1px solid #2155b5;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: #575757;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
  margin-bottom: 15px;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.file:hover {
  background: rgba(218, 218, 218, 0.2);
  color: #000;
  text-decoration: none;
}
.percentage-text {
  width: 86%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
.percentage-sign {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  // color: #999;
  margin: 14px 0 15px 10px;
  color: #e5914b;
  cursor: pointer;
}
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }
  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }
  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
</style>